"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@chakra-ui/react");
function DataField({ label, value, children, }) {
    return ((0, jsx_runtime_1.jsxs)(react_1.Box, Object.assign({ mb: 4 }, { children: [(0, jsx_runtime_1.jsx)(react_1.Heading, Object.assign({ size: "sm", mb: 1, opacity: 0.5 }, { children: label })), value ? (0, jsx_runtime_1.jsx)(react_1.Text, Object.assign({ fontWeight: "medium" }, { children: value })) : null, children] })));
}
exports.DataField = DataField;
